<span class="close-icon" style="cursor: pointer" (click)="onCloseModal()">
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.26562 32.7093L0.859375 30.2155L14.0937 16.4999L0.859375 2.78428L3.26562 0.290527L16.5 14.0062L29.7344 0.290527L32.1406 2.78428L18.9062 16.4999L32.1406 30.2155L29.7344 32.7093L16.5 18.9937L3.26562 32.7093Z"
            fill="#ACACAC" />
    </svg>
</span>
<div id="add-simulation" class="add-simulation-cotainer model-cotainer">
    <h2 mat-dialog-title class="font-bold title add-simulation" *ngIf="actionType == 'create'">
        {{ 'CreateOrUpdateSimulation.AddSimulation' | translate }}
    </h2>
    <h2 mat-dialog-title class="font-bold title add-simulation" *ngIf="actionType == 'update'">
        {{ 'CreateOrUpdateSimulation.UpdateSimulation' | translate }}
    </h2>
    <div class="row-tab d-flex align-items-center">
        <div class="tab" [ngClass]="lstTab?.indexOf(1) != -1 ? 'active' : ''" (click)="activeTab = 1; lstTab = [1]">
            <span class="number float-left">1</span>
            <span class="text font-bold">{{ 'CreateOrUpdateSimulation.SimulationDetails' | translate }}</span>
        </div>
        <div class="tab" [ngClass]="lstTab?.indexOf(2) != -1 ? 'active' : ''" (click)="clickContinue()">
            <span class="number float-left">2</span>
            <span class="text font-bold">{{ 'CreateOrUpdateSimulation.SimulationSettings' | translate }}</span>
        </div>
    </div>
    <form class="form" #myForm="ngForm" novalidate>
        <div class="content-tab-1" [hidden]="activeTab == 2">
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'SimulationName' | translate }}</label>
                <input type="text" maxlength="100" class="input-text w-100" name="name"
                    [(ngModel)]="createOrUpdateModel.detailsRequest.name"
                    placeholder="{{ 'CreateOrUpdateSimulation.EnterSimulationName' | translate }}" [ngClass]="
                        nameCtrl.hasError('required') && (nameCtrl.touched || myForm.submitted) ? 'input-error' : ''
                    " required #nameCtrl="ngModel" />
                <mat-error *ngIf="nameCtrl.hasError('required') && (nameCtrl.touched || myForm.submitted)">{{
                    'ValidationMessage.RequiredSimulationName' | translate
                    }}</mat-error>
            </div>
            <div class="row form-field w-100">
                <div class="w-50 float-left date-time-col" appearance="fill">
                    <label class="label">{{ 'CreateOrUpdateSimulation.DateOfSimulation' | translate }}</label>
                    <div class="d-flex align-items-center date-time-container position-relative" [ngClass]="
                            startDateCtrl.hasError('required') && (startDateCtrl.touched || myForm.submitted)
                                ? 'input-error'
                                : ''
                        ">
                        <input matInput [matDatepicker]="picker" [(ngModel)]="dateOfSimulation" name="startDate"
                            (focus)="picker.open()" placeholder="{{ 'Text_SelectDate' | translate }}" class="h-100"
                            required #startDateCtrl="ngModel"
                            [min]="minDate"
                            />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                    <mat-error
                        *ngIf="startDateCtrl.hasError('required') && (startDateCtrl.touched || myForm.submitted)">{{
                        'ValidationMessage.RequiredDateOfSimulation' | translate }}</mat-error>
                </div>
                <div class="w-50 float-left time-col" appearance="fill">
                    <label class="label"> {{ 'CreateOrUpdateSimulation.TimeOfSimulation' | translate }}</label>
                    <div class="d-flex align-items-center time-container" [ngClass]="
                            timeCtrl.hasError('required') && (timeCtrl.touched || myForm.submitted) ? 'input-error' : ''
                        ">
                        <input type="text" class="input-time" placeholder="{{ 'Text_SelectTime' | translate }}"
                            #toggleButton (focus)="toggleSelectTime()" id="toogleButton"
                            [(ngModel)]="inputTime" name="startTime"
                            #timeCtrl="ngModel" readonly required />
                        <span class="position-relative">
                            <img class="icon-clock" #toggleButton1 (click)="toggleSelectTime()" id="toogleButton1"
                                src="../../../../../assets/images/icon-clock.png" alt="clock" />
                            <div class="menu" [hidden]="!isMenuOpen" class="position-absolute menu-set-time" #menu>
                                <div class="line-time">
                                    <input type="text" class="input-time-minute input-text algin-center font-bold"
                                        id="ip-minute" name="minuteName" [(ngModel)]="minute" (change)="setMinute()" />
                                    <span class="minute-dots-second">:</span>
                                    <input type="text" class="input-time-second input-text algin-center font-bold"
                                        id="ip-second" name="secondName" [(ngModel)]="second" (change)="setSecond()" />
                                    <!-- <div class="box-am-pm">
                                        <span
                                            class="am"
                                            id="am"
                                            (click)="activeAm = true; activePm = false"
                                            [ngClass]="activeAm ? 'active' : ''"
                                            >{{ 'Am' | translate }}</span
                                        >
                                        <span
                                            class="pm"
                                            id="pm"
                                            (click)="activePm = true; activeAm = false"
                                            [ngClass]="activePm ? 'active' : ''"
                                            >{{ 'Pm' | translate }}</span
                                        >
                                    </div> -->
                                </div>
                                <div class="btn-common-style btn-set-time font-bold" id="btn-set-time"
                                    (click)="setTime()" style="cursor: pointer">
                                    {{ 'Btn_SetTime' | translate }}
                                </div>
                            </div>
                        </span>
                    </div>
                    <mat-error *ngIf="timeCtrl.hasError('required') && (timeCtrl.touched || myForm.submitted)">{{
                        'ValidationMessage.RequiredTimeOfSimulation' | translate
                        }}</mat-error>
                    <mat-error *ngIf="validateTime">{{
                        'ValidationMessage.ValidateTimeOfSimulation' | translate
                        }}</mat-error>
                </div>
                <span class="date-time-warning"> {{ 'CreateOrUpdateSimulation.DateTimeWarning' | translate }}</span>
            </div>

            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'Text_Organization' | translate }}</label>
                <mat-select placeholder="{{ 'Text_SelectOrganization' | translate }}" class="simu-main-dropdown w-100"
                    [ngClass]="
                        organizationCtrl.hasError('required') && (organizationCtrl.touched || myForm.submitted)
                            ? 'input-error'
                            : ''
                    " required #organizationCtrl="ngModel" [disableOptionCentering]="true"
                    [(ngModel)]="createOrUpdateModel.detailsRequest.organizationId" name="oranizationId"
                    (selectionChange)="onChangeOrg($event.value)"
                    panelClass="drop-panel">
                    <mat-option *ngFor="let org of listOrganization" [value]="org.id">
                        {{ org.name }}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="organizationCtrl.hasError('required') && (organizationCtrl.touched || myForm.submitted)">{{
                    'ValidationMessage.RequiredOrganization' | translate }}</mat-error>
            </div>
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'Text_SimulationType' | translate }}</label>
                <mat-select required placeholder="{{ 'Text_SelectSimulationType' | translate }}"
                    class="simu-main-dropdown w-100" [disableOptionCentering]="true" [ngClass]="
                        simulationTypeCtrl.hasError('required') && (simulationTypeCtrl.touched || myForm.submitted)
                            ? 'input-error'
                            : ''
                    " #simulationTypeCtrl="ngModel"
                    [(ngModel)]="createOrUpdateModel.detailsRequest.simulationTypeId" name="simulationTypeId"
                    panelClass="drop-panel">
                    <mat-select-trigger *ngIf="selectedTypes">
                        {{ selectedTypes.name }}
                    </mat-select-trigger>
                    <mat-option *ngFor="let type of listSimulationType" [value]="type.id"
                        class="simulation-type-option">
                        <div class="name-simulation-type">{{ type.name }}</div>
                        <div class="description-simulation-type">{{ type.description }}</div>
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="simulationTypeCtrl.hasError('required') && (simulationTypeCtrl.touched || myForm.submitted)">{{
                    'ValidationMessage.RequiredSimulationType' | translate }}</mat-error>
                <!-- <div class="lst-simulation-type" *ngIf="listSimulationTypeSelected?.length > 0 && showDesc">
                    <div class="item" *ngFor="let type of listSimulationTypeSelected">
                        {{ type.description }}
                    </div>
                </div> -->
                <!-- <div class="lbl-add-new-simulation" (click)="openAddSimulationTypeForm()">
                    + {{ 'CreateOrUpdateSimulation.AddNewSimulationType' | translate }}
                </div> -->
            </div>
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'CreateOrUpdateSimulation.RoomNumber' | translate }}</label>
                <input type="text" maxlength="50" class="input-text w-100"
                    [(ngModel)]="createOrUpdateModel.detailsRequest.roomNumber" name="roomNumber" required
                    placeholder="{{ 'CreateOrUpdateSimulation.EnterRoomNumber' | translate }}" [ngClass]="
                        (roomNumberCtrl.hasError('isValidRoomNumber') && (roomNumberCtrl.touched || myForm.submitted)) ||
                        (roomNumberCtrl.hasError('required') && (roomNumberCtrl.touched || myForm.submitted))
                            ? 'input-error'
                            : ''
                    " #roomNumberCtrl="ngModel" />

                <mat-error *ngIf="
                        roomNumberCtrl.hasError('isValidRoomNumber') &&
                        (roomNumberCtrl.touched || myForm.submitted)
                    ">{{ 'ValidationMessage.IsValidRoomNumber' | translate }}</mat-error>
                <mat-error *ngIf="
                    roomNumberCtrl.hasError('required') &&
                    (roomNumberCtrl.touched || myForm.submitted)
                ">{{ 'ValidationMessage.RequiredRoomNumber' | translate }}</mat-error>
            </div>
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'CreateOrUpdateSimulation.ParticipentLogAvailible' | translate }}</label>
                <input type="number" min="1" class="input-text w-100"
                    [(ngModel)]="createOrUpdateModel.detailsRequest.participantLogAvailable"
                    name="participantLogAvailable"
                    placeholder="{{ 'CreateOrUpdateSimulation.EnterNumberOfDays' | translate }}" [ngClass]="
                        (participantLogAvailableCtrl.hasError('required') ||
                            participantLogAvailableCtrl.hasError('isValidLogAvailable')) &&
                        (participantLogAvailableCtrl.touched || myForm.submitted)
                            ? 'input-error'
                            : ''
                    " required [customValidator]="validatorLogAvailable" #participantLogAvailableCtrl="ngModel" />
                <mat-error *ngIf="
                        participantLogAvailableCtrl.hasError('required') &&
                        (participantLogAvailableCtrl.touched || myForm.submitted)
                    ">{{ 'ValidationMessage.RequiredparticipantLogAvailable' | translate }}</mat-error>
                <mat-error *ngIf="
                        !participantLogAvailableCtrl.hasError('required') &&
                        participantLogAvailableCtrl.hasError('isValidLogAvailable') &&
                        (participantLogAvailableCtrl.touched || myForm.submitted)
                    ">{{ 'ValidationMessage.IsValidLogAvailable' | translate }}</mat-error>

                <div class="lbl-days-after">{{ 'CreateOrUpdateSimulation.DayAfter' | translate }}</div>
            </div>
            <button mat-button class="btn-continue font-bold btn-common-style float-right" (click)="clickContinue()">
                Continue
            </button>
        </div>
    </form>
    <form class="form" #myFormTab2="ngForm" novalidate>
        <div class="content-tab-2" [hidden]="activeTab == 1">
            <div class="form-field w-100" appearance="fill">
                <label class="label">{{ 'CreateOrUpdateSimulation.LoginCode' | translate }}</label>
                <input type="text" class="input-text w-100 disabled"
                    placeholder="{{ 'CreateOrUpdateSimulation.EnterLoginCode' | translate }}"
                    [(ngModel)]="createOrUpdateModel.settingsRequest.loginCode" name="loginCode" readonly />
                <div class="lbl-days-after">{{ 'CreateOrUpdateSimulation.ThisCodeDetail' | translate }}</div>
            </div>

            <div class="form-field w-100 position-relative" appearance="fill">
                <label class="label">{{ 'CreateOrUpdateSimulation.SimulationLink' | translate }}</label>
                <input type="text" class="input-text w-100 disabled"
                    placeholder="{{ 'CreateOrUpdateSimulation.EnterSimulationLink' | translate }}"
                    [(ngModel)]="inviteLink" name="link" readonly style="font-size: 11px; padding: 0px 34px 0 18px;"
                    #simulationlinkinput />
                <span class="icon-copy position-absolute" (click)="copySimulationLink()" matTooltip="Copied!"
                    [matTooltipDisabled]="true" #matTooltipCopied="matTooltip" [matTooltipShowDelay]="0"
                    [matTooltipHideDelay]="1000">
                    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.45 21.2251C1.98333 21.2251 1.58333 21.0584 1.25 20.7251C0.916667 20.3918 0.75 19.9918 0.75 19.5251V4.5001H2.45V19.5251H14.25V21.2251H2.45ZM5.65 18.0251C5.2 18.0251 4.80417 17.8543 4.4625 17.5126C4.12083 17.1709 3.95 16.7751 3.95 16.3251V2.4251C3.95 1.95843 4.12083 1.55843 4.4625 1.2251C4.80417 0.891764 5.2 0.725098 5.65 0.725098H16.55C17.0167 0.725098 17.4167 0.891764 17.75 1.2251C18.0833 1.55843 18.25 1.95843 18.25 2.4251V16.3251C18.25 16.7751 18.0833 17.1709 17.75 17.5126C17.4167 17.8543 17.0167 18.0251 16.55 18.0251H5.65ZM5.65 16.3251H16.55V2.4251H5.65V16.3251ZM5.65 16.3251V2.4251V16.3251Z"
                            fill="#17B978" />
                    </svg>
                </span>
            </div>
            <div class="form-field w-100" appearance="fill">
                <mat-checkbox class="example-margin" [checked]="false"
                    [(ngModel)]="createOrUpdateModel.settingsRequest.acceptJoinViaLink" name="aceptJoinViaLink">
                    {{ 'CreateOrUpdateSimulation.AllowAnyoneToJoinLink' | translate }}
                </mat-checkbox>
            </div>
            <div *ngIf="!createOrUpdateModel.settingsRequest.acceptJoinViaLink" class="form-field w-100 invite-people" appearance="fill" [ngClass]="
                    (createOrUpdateModel?.settingsRequest?.invitePeople.length == 0 && !createOrUpdateModel.settingsRequest.acceptJoinViaLink) &&
                    (chipList.touched || myFormTab2.submitted)
                        ? 'chipList-error'
                        : ''
                ">
                <label class="label"> {{ 'CreateOrUpdateSimulation.InvitePeople' | translate }}</label>
                <mat-chip-list #chipList aria-label="Fruit selection">
                    <mat-chip class="font-bold"
                        *ngFor="let people of this.createOrUpdateModel?.settingsRequest?.invitePeople"
                        (removed)="remove(people.email)">
                        {{ people.email }}
                        <button matChipRemove>
                            <mat-icon>
                                <svg width="18" height="19" viewBox="0 0 18 19" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="9" cy="9.5" r="9" fill="#086972" />
                                    <path
                                        d="M5.63105 13.4811L5.01855 12.8686L8.3873 9.4998L5.01855 6.13105L5.63105 5.51855L8.9998 8.8873L12.3686 5.51855L12.9811 6.13105L9.6123 9.4998L12.9811 12.8686L12.3686 13.4811L8.9998 10.1123L5.63105 13.4811Z"
                                        fill="white" />
                                </svg>
                            </mat-icon>
                        </button>
                    </mat-chip>
                    <input #peopleInput class="input-text border-0"
                        placeholder="{{ 'CreateOrUpdateSimulation.EnterEmail' | translate }}" [formControl]="peopleCtrl"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)" />
                </mat-chip-list>
                <mat-error *ngIf="
                        createOrUpdateModel?.settingsRequest?.invitePeople.length == 0 &&
                        (chipList.touched || myFormTab2.submitted) && !createOrUpdateModel.settingsRequest.acceptJoinViaLink
                    ">{{ 'ValidationMessage.RequiredInvitePeople' | translate }}</mat-error>
                <div class="lbl-days-after">{{ 'CreateOrUpdateSimulation.MultipleEmails' | translate }}</div>

                <div *ngIf="actionType == 'update'">
                    <mat-checkbox class="example-margin" [(ngModel)]="createOrUpdateModel.settingsRequest.resendEmail"
                        name="resendEmail">
                        {{ 'CreateOrUpdateSimulation.ResendEmail' | translate }}
                    </mat-checkbox>
                </div>
            </div>
            <div class="box-btn">
                <button mat-button class="btn-back font-bold btn-common-style float-left" (click)="clickBtnBack()">
                    {{ 'CreateOrUpdateSimulation.Back' | translate }}
                </button>
                <button mat-button class="btn-continue font-bold btn-common-style float-right"
                    (click)="clickUpdate(myFormTab2)" *ngIf="actionType == 'create'">
                    {{ 'CreateOrUpdateSimulation.CreateSimulation' | translate }}
                </button>
                <button mat-button class="btn-continue font-bold btn-common-style float-right"
                    (click)="clickUpdate(myFormTab2)" *ngIf="actionType == 'update'">
                    {{ 'CreateOrUpdateSimulation.UpdateSimulation' | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
